// customise.js.liquid - controls product selectors for collection.customise
jQuery(document).ready(function ($) {
// check what the current top / base
var currentBase = $( ".rotator.active" ).data( "bottom" )
var currentTop = $( ".rotator.active" ).data( "top" )

//grey out the variants to start with
  // TOP
  // check what the available bottom variants are
  var variants = $('#topSelector button.active').data('variants').replace(/\s/g, '').slice(0,-1)
  //split the variants into individual ids and apply greyed class to unavailable variations
  var buttons = $( "div#bottomSelector div button" )
    variants.split(",").forEach(function(each) {
      var id = '#' + each
        buttons = $(buttons).not( id )
    });
  $(buttons).addClass('greyed')
  //BOTTOM
  // check what the available variants are
  var variants = $('#bottomSelector button.active').data('variants').replace(/\s/g, '').slice(0,-1)
  //split the variants into individual ids and apply greyed class to unavailable variations
  var buttons = $( "div#topSelector div button" )
    variants.split(",").forEach(function(each) {
      var id = '#' + each
        buttons = $(buttons).not( id )
    });
  $(buttons).addClass('greyed')

  // format string for tooltip
  var greyedBase = currentBase.replace(/-/g, ' ')
  var greyedTop = currentTop.replace(/-/g, ' ')
  // add current base name to tooltip
  $('#topSelector span.tooltip em').text( greyedBase )
  $('#bottomSelector span.tooltip em').text( greyedTop )

$('#topSelector').on('click', 'button', function() {

  // Add and remove active class as needed
  $('#topSelector button.active').removeClass("active")
  $(this).addClass('active')
  // Get the id of the button clicked
  var topFilter = (this.id)

  // check what the available variants are
  var variants = $(this).data('variants').replace(/\s/g, '').slice(0,-1)
  // remove the greyed class from all
  $( "div#bottomSelector div button" ).removeClass('greyed')
  //split the variants into individual ids and apply greyed class to unavailable variations
  var buttons = $( "div#bottomSelector div button" )
    variants.split(",").forEach(function(each) {
      var id = '#' + each
        buttons = $(buttons).not( id );
    });
  $(buttons).addClass('greyed')

  // check what the current top / base so we only change one product not all with same top / base
  var currentBase = $( ".rotator.active" ).data( "bottom" )
  var currentTop = $( ".rotator.active" ).data( "top" )
  // Hide non current product
  $( ".rotator.active" )
    .addClass('not-active')
    .removeClass('active');// Hide
  // Hide current price
  $( "#visible-cart .active" )
    .addClass('not-active')
    .removeClass('active');// Hide

  //Show the item that has the current base and the top of the button that was clicked.
  $( "div#product-selector .rotator" )
    .filter("[data-bottom="+ currentBase +"]")
    .filter("[data-top="+ topFilter +"-top]")
    .addClass('active')
    .removeClass('not-active');
  //Show the price that has the current base and the top of the button that was clicked.
  $( "#visible-cart div" )
    .filter("[data-bottom="+ currentBase +"]")
    .filter("[data-top="+ topFilter +"-top]")
    .addClass('active')
    .removeClass('not-active');

  // re-check what the current top / base so we only change one product not all with same top / base
  var currentBase = $( ".rotator.active" ).data( "bottom" )
  var currentTop = $( ".rotator.active" ).data( "top" )
  // format string for tooltip
    var greyedBase = currentBase.replace(/-/g, ' ')
    var greyedTop = currentTop.replace(/-/g, ' ')
    // add current base name to tooltip
    $('#topSelector span.tooltip em').text( greyedBase )
    $('#bottomSelector span.tooltip em').text( greyedTop )
});

$('#bottomSelector').on('click', 'button', function() {
  // Add and remove active class as needed
  $('#bottomSelector button.active').removeClass('active')
  $(this).addClass('active')
  // Get the id of the button clicked
  var bottomFilter = (this.id)

    // check what the available variants are
  var variants = $(this).data('variants').replace(/\s/g, '').slice(0,-1);
  // remove the greyed class from all
  $( "div#topSelector div button" ).removeClass('greyed')
  //split the variants into individual ids and apply greyed class to unavailable variations
  var buttons = $( "div#topSelector div button" )
    variants.split(",").forEach(function(each) {
      var id = '#' + each
        buttons = $(buttons).not( id )
    });
  $(buttons).addClass('greyed')


  // check what the current top / base
  var currentBase = $( ".rotator.active" ).data( "bottom" )
  var currentTop = $( ".rotator.active" ).data( "top" )
  // Hide non matching products
  $(".rotator.active" )
    .addClass('not-active')
    .removeClass('active');// Hide
  // Hide current price
  $( "#visible-cart .active" )
    .addClass('not-active')
    .removeClass('active');// Hide
  //Show the item that has the current base and the top of the button that was clicked.
  $("div#product-selector .rotator" )
    .filter("[data-top="+ currentTop +"]")
    .filter("[data-bottom="+ bottomFilter +"-base]")
    .addClass('active')
    .removeClass('not-active')// Show
  //Show the price that has the current base and the top of the button that was clicked.
  $( "#visible-cart div" )
    .filter("[data-top="+ currentTop +"]")
    .filter("[data-bottom="+ bottomFilter +"-base]")
    .addClass('active')
    .removeClass('not-active')// Show

  // re-check what the current top / base
  var currentBase = $( ".rotator.active" ).data( "bottom" )
  var currentTop = $( ".rotator.active" ).data( "top" )
  // format string for tooltip
  var greyedBase = currentBase.replace(/-/g, ' ')
  var greyedTop = currentTop.replace(/-/g, ' ')
  // add current base name to tooltip
  $('#topSelector span.tooltip em').text( greyedBase )
  $('#bottomSelector span.tooltip em').text( greyedTop )
});
//End Jquery
});
